import { useEffect, useMemo } from 'react'

import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput, FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Trades } from '@fortem-monorepo/web-sdk'

const isTruthy = (number: number | null | undefined) => {
  return number !== null && number !== undefined && !isNaN(number)
}

export interface NotionalFormFieldProps {}

export const NotionalFormField: React.FC<NotionalFormFieldProps> = ({}) => {
  const { control, register, watch, setValue, getValues } = useFormContext<Trades.BookTradeBody>()

  const price = watch('price')
  const price_format = watch('price_format')
  const quantity = watch('quantity')
  const unit_multiplier = watch('unit_multiplier')

  const nextNotional = useMemo(() => {
    if (isTruthy(price) && isTruthy(quantity) && isTruthy(unit_multiplier)) {
      const new_price = price_format === 'decimal' ? price : price / 100

      const nextNotional =
        new_price === 0 ? 0 : parseFloat((new_price * quantity * unit_multiplier).toFixed(2))

      return nextNotional
    }

    return null
  }, [price, price_format, quantity, unit_multiplier])

  useEffect(() => {
    const currentNotional = getValues('notional')

    if (nextNotional !== currentNotional) {
      setValue('notional', nextNotional!)
    }
  }, [nextNotional])

  return (
    <FormField
      name="notional"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Notional</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              thousandSeparator={','}
              disabled
              placeholder="Notional"
              {...register('notional', { valueAsNumber: true })}
            />
          </FormItem>
        )
      }}
    />
  )
}
